<template lang="pug">
	.dropdown-display-object-actions
		.dropdown-control(:class="{active: active}" v-pseudo-modal-show="this._uid + '-dropdown-display-object-actions'")
			.drop-icon.fa.fa-bars
			.dropdown-menu(v-pseudo-modal="this._uid + '-dropdown-display-object-actions'" :style="{'max-height': `90vh`}" v-on:mouseover="active = true" v-on:mouseout="active = false")
				.dropdown-item(@click="cloneDisplayObject()")
					.property-title Clone
						.shortcut &lt;CTRL&gt; + drag in tree
					.property-description Make a copy of display object and all its children
				.dropdown-item(@click="deleteDisplayObject($event)")
					.property-title.text-danger Delete
						.shortcut &lt;DEL&gt;
					.property-description Remove display object and all its children
</template>

<script>
	import Screen from './../../mixins/screen'

	export default {
		name: 'DropdownDisplayObjectActions',
		mixins: [Screen],
		screen: {
			updateOn: []
		},
		props: {
			displayObject: {
				type: Object,
				default: null
			}
		},
		data() {

			return {
				showed: true,
				active: false
			};

		},
		methods: {
			collectData() {

			},
			cloneDisplayObject() {

				Server.sendToSocket({
					CloneDisplayObject: {
						versionId: Version.SelectedVersion.id,
						screenCodename: this.displayObject['screen_codename'],
						displayObjectCodename: this.displayObject.codename
					}
				});

			},
			deleteDisplayObject(e) {

				if (!DisplayObject.SelectedDisplayObject) return;

				Broadcast.call('Show Confirm', [{
					caption: 'Delete display object',
					message: `Are you sure you want to delete display object "${DisplayObject.SelectedDisplayObject.codename}"? It will delete all child objects as well.`,
					confirmButtonText: '&nbsp;&nbsp;Delete object',
					confirmButtonIcon: 'fa-remove',
					forceConfirm: e.shiftKey,
					confirmCallback: () => {
						Server.sendToSocket({
							DeleteDisplayObject: {
								versionId: Version.SelectedVersion.id,
								screenCodename: this.displayObject['screen_codename'],
								displayObjectCodename: this.displayObject.codename
							}
						});
					}
				}]);

			}
		}
	}
</script>

<style lang="sass">

	.dropdown-display-object-actions
		position: relative
		margin-top: 1px
		user-select: none

		.dropdown-control
			border: none
			background: transparent
			color: rgba(255, 255, 255, 0.5)
			cursor: pointer
			font-size: 14px
			padding: 3px 10px
			position: relative

			.drop-icon
				color: rgba(255, 255, 255, 0.50)

		.dropdown-control:hover, .dropdown-control.active

			.drop-icon
				color: #20a8d8

		.dropdown-menu
			top: 28px
			left: auto
			right: 0
			border-color: #3f454b
			width: 190px
			margin: 0
			padding: 0
			overflow: visible

			.dropdown-item
				display: flex
				flex-direction: column
				justify-content: start
				padding: 0.25rem
				padding-left: 0.55rem
				font-size: 0.765625rem
				border-bottom: 1px solid rgba(0, 0, 0, 0.2)
				background-color: #555b5f

				&:last-child
					border-bottom: none

				&:hover
					background-color: #646a6f

				.fa
					display: flex
					align-items: center
					justify-content: center

				.property-title
					color: rgba(255,255,255,1)
					margin-left: 0
					white-space: nowrap
					font-size: 13px
					position: relative

					.shortcut
						position: absolute
						right: 0px
						top: 2px
						color: rgba(255, 255, 255, 0.2)
						font-size: 11px

				.property-description
					width: 160px
					margin-left: 0
					white-space: normal
					font-size: 11px
					color: rgba(255,255,255,0.4)

		.dropdown-control.empty
			color: rgba(255, 255, 255, 0.30)
			padding-right: 0.5rem

			.drop-icon
				display: none

			.dropdown-menu
				display: none

</style>
